<template>
  <div class="left-panel">
    <div class="left-panel-heading">
      <img src="@/assets/images/main-logo.png" alt="Volkswagen">
    </div>
    <navigation/>
  </div>
</template>

<script>
import Navigation from './Navigation.vue';

export default {
  name: 'left-panel',

  components: {
    Navigation,
  },
};
</script>

<style lang="scss" scoped>
.left-panel {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  background: var(--light-grey-color);

  .left-panel-heading {
    height: 64px;
    background: var(--dark-grey-color);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px;

    img {
      height: 62px;
    }
  }
}
</style>
